import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { HomePage } from "@/pages/Home";

const ForHubPage = lazy(() => import("@/pages/ForHub").then((m) => ({ default: m.ForHubPage })));
const RolePage = lazy(() => import("@/pages/RolePage").then((m) => ({ default: m.RolePage })));
const VsOpenclawPage = lazy(() => import("@/pages/VsOpenclaw").then((m) => ({ default: m.VsOpenclawPage })));
const PricingPage = lazy(() => import("@/pages/Pricing").then((m) => ({ default: m.PricingPage })));
const IntegrationsPage = lazy(() => import("@/pages/Integrations").then((m) => ({ default: m.IntegrationsPage })));
const AboutPage = lazy(() => import("@/pages/About").then((m) => ({ default: m.AboutPage })));
const BlogPage = lazy(() => import("@/pages/Blog").then((m) => ({ default: m.BlogPage })));
const BlogPostPage = lazy(() => import("@/pages/BlogPost").then((m) => ({ default: m.BlogPostPage })));
const WorkflowsPage = lazy(() => import("@/pages/WorkflowsPage").then((m) => ({ default: m.WorkflowsPage })));
const SetupPage = lazy(() => import("@/pages/Setup").then((m) => ({ default: m.SetupPage })));
const SetupPricingPage = lazy(() => import("@/pages/SetupPricing").then((m) => ({ default: m.SetupPricingPage })));
const LandingPage = lazy(() => import("@/pages/LandingPage").then((m) => ({ default: m.LandingPage })));
const NotFoundPage = lazy(() => import("@/pages/NotFound").then((m) => ({ default: m.NotFoundPage })));

export function App() {
  return (
    <Suspense>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="for" element={<ForHubPage />} />
          <Route path="for/:slug" element={<RolePage />} />
          <Route path="for/:slug/workflows" element={<WorkflowsPage />} />
          <Route path="vs/openclaw" element={<VsOpenclawPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="integrations" element={<IntegrationsPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path="setup" element={<SetupPage />} />
          <Route path="setup/pricing" element={<SetupPricingPage />} />
          <Route path="lp/:variant" element={<LandingPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
